module.exports = __webpack_public_path__ + "270ffe0dd1d0fa5b9a5863318d8ea960.pdf";